import { PROGRAM_CATEGORIES } from '@repo/types';

// Category options derived directly from the frontend enum — no API call needed.
export const PROGRAM_CATEGORY_OPTIONS = PROGRAM_CATEGORIES.map((value) => ({
  value,
  label: value.charAt(0).toUpperCase() + value.slice(1),
}));

/**
 * Returns the static list of program categories.
 * Categories are an enum (course | material | certificate), not a DB collection.
 */
export function useSharedCategories() {
  return {
    data: PROGRAM_CATEGORY_OPTIONS,
    isLoading: false,
    isError: false,
  };
}
